var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9657",
    "data-name": "Group 9657",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f8f8f8;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9624",
    "data-name": "Group 9624",
    transform: "translate(84.375 95.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9623",
    "data-name": "Group 9623"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2722",
    "data-name": "Rectangle 2722",
    className: "cls-2",
    width: 5.625,
    height: 3.75
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9625",
    "data-name": "Group 9625",
    transform: "translate(45 1.875)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2723",
    "data-name": "Rectangle 2723",
    className: "cls-2",
    width: 3.75,
    height: 11.25
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9626",
    "data-name": "Group 9626",
    transform: "translate(7.5 30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2724",
    "data-name": "Rectangle 2724",
    className: "cls-2",
    width: 20.625,
    height: 3.75
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9635",
    "data-name": "Group 9635",
    transform: "translate(26.25 11.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9627",
    "data-name": "Group 9627",
    transform: "translate(30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6982",
    "data-name": "Path 6982",
    className: "cls-2",
    d: "M41.25,17.25H30V6H41.25Zm-7.5-3.75H37.5V9.75H33.75Z",
    transform: "translate(-30 -6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9628",
    "data-name": "Group 9628",
    transform: "translate(30 15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6983",
    "data-name": "Path 6983",
    className: "cls-2",
    d: "M41.25,25.25H30V14H41.25Zm-7.5-3.75H37.5V17.75H33.75Z",
    transform: "translate(-30 -14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9629",
    "data-name": "Group 9629",
    transform: "translate(30 30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6984",
    "data-name": "Path 6984",
    className: "cls-2",
    d: "M41.25,33.25H30V22H41.25Zm-7.5-3.75H37.5V25.75H33.75Z",
    transform: "translate(-30 -22)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9630",
    "data-name": "Group 9630",
    transform: "translate(15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6985",
    "data-name": "Path 6985",
    className: "cls-2",
    d: "M33.25,17.25H22V6H33.25Zm-7.5-3.75H29.5V9.75H25.75Z",
    transform: "translate(-22 -6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9631",
    "data-name": "Group 9631",
    transform: "translate(15 30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6986",
    "data-name": "Path 6986",
    className: "cls-2",
    d: "M33.25,33.25H22V22H33.25Zm-7.5-3.75H29.5V25.75H25.75Z",
    transform: "translate(-22 -22)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9632",
    "data-name": "Group 9632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6987",
    "data-name": "Path 6987",
    className: "cls-2",
    d: "M25.25,17.25H14V6H25.25Zm-7.5-3.75H21.5V9.75H17.75Z",
    transform: "translate(-14 -6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9633",
    "data-name": "Group 9633",
    transform: "translate(0 15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6988",
    "data-name": "Path 6988",
    className: "cls-2",
    d: "M25.25,25.25H14V14H25.25Zm-7.5-3.75H21.5V17.75H17.75Z",
    transform: "translate(-14 -14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9634",
    "data-name": "Group 9634",
    transform: "translate(0 30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6989",
    "data-name": "Path 6989",
    className: "cls-2",
    d: "M25.25,33.25H14V22H25.25Zm-7.5-3.75H21.5V25.75H17.75Z",
    transform: "translate(-14 -22)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9636",
    "data-name": "Group 9636",
    transform: "translate(60 50.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6990",
    "data-name": "Path 6990",
    className: "cls-2",
    d: "M69.5,47.625h-30v-7.5H32V27h3.75v9.375h7.5v7.5H69.5Z",
    transform: "translate(-32 -27)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9637",
    "data-name": "Group 9637",
    transform: "translate(93.75 37.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2725",
    "data-name": "Rectangle 2725",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9638",
    "data-name": "Group 9638",
    transform: "translate(65.625 30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6991",
    "data-name": "Path 6991",
    className: "cls-2",
    d: "M48.125,34.75H35V31h9.375V19.75H35V16H48.125Z",
    transform: "translate(-35 -16)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9639",
    "data-name": "Group 9639",
    transform: "translate(82.5 15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2726",
    "data-name": "Rectangle 2726",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9640",
    "data-name": "Group 9640",
    transform: "translate(82.5 22.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2727",
    "data-name": "Rectangle 2727",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9641",
    "data-name": "Group 9641",
    transform: "translate(90 22.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2728",
    "data-name": "Rectangle 2728",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9642",
    "data-name": "Group 9642",
    transform: "translate(82.5 30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2729",
    "data-name": "Rectangle 2729",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9643",
    "data-name": "Group 9643",
    transform: "translate(45 50.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6992",
    "data-name": "Path 6992",
    className: "cls-2",
    d: "M35.25,96.375H31.5v-45H24V27h3.75V47.625h7.5Z",
    transform: "translate(-24 -27)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9644",
    "data-name": "Group 9644",
    transform: "translate(60 1.875)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2730",
    "data-name": "Rectangle 2730",
    className: "cls-2",
    width: 3.75,
    height: 11.25
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9645",
    "data-name": "Group 9645",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6993",
    "data-name": "Path 6993",
    className: "cls-2",
    d: "M21.125,41.75H8V8H21.125v3.75H11.75V38h9.375Z",
    transform: "translate(-8 -8)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9646",
    "data-name": "Group 9646",
    transform: "translate(30 50.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6994",
    "data-name": "Path 6994",
    className: "cls-2",
    d: "M31,96.375H27.25V68.625L16.188,46.5C16,46.313,16,46.125,16,45.75V27h3.75V45.375L30.813,67.5c.188.188.188.375.188.75Z",
    transform: "translate(-16 -27)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9647",
    "data-name": "Group 9647",
    transform: "translate(60 67.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2731",
    "data-name": "Rectangle 2731",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9648",
    "data-name": "Group 9648",
    transform: "translate(52.5 56.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2732",
    "data-name": "Rectangle 2732",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9649",
    "data-name": "Group 9649",
    transform: "translate(52.5 63.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2733",
    "data-name": "Rectangle 2733",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9650",
    "data-name": "Group 9650",
    transform: "translate(60 75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2734",
    "data-name": "Rectangle 2734",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9651",
    "data-name": "Group 9651",
    transform: "translate(67.5 75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2735",
    "data-name": "Rectangle 2735",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9652",
    "data-name": "Group 9652",
    transform: "translate(65.625 15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6995",
    "data-name": "Path 6995",
    className: "cls-2",
    d: "M48.125,19.25h-3.75v-7.5H35V8H48.125Z",
    transform: "translate(-35 -8)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9653",
    "data-name": "Group 9653",
    transform: "translate(76.875 37.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2736",
    "data-name": "Rectangle 2736",
    className: "cls-2",
    width: 13.125,
    height: 3.75
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9654",
    "data-name": "Group 9654",
    transform: "translate(41.25 26.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6996",
    "data-name": "Path 6996",
    className: "cls-2",
    d: "M33.25,25.25H22V14H33.25Zm-7.5-3.75H29.5V17.75H25.75Z",
    transform: "translate(-22 -14)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9655",
    "data-name": "Group 9655",
    transform: "translate(54.375 82.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6997",
    "data-name": "Path 6997",
    className: "cls-2",
    d: "M38.375,81.5h-3.75V47.75H29V44h9.375Z",
    transform: "translate(-29 -44)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9656",
    "data-name": "Group 9656",
    transform: "translate(37.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6998",
    "data-name": "Path 6998",
    className: "cls-2",
    d: "M68.75,120H65V97.5a1.771,1.771,0,0,1,1.875-1.875h11.25A9.284,9.284,0,0,0,87.5,86.25V69.375A1.771,1.771,0,0,1,89.375,67.5H98.75V66L87.688,42a1.127,1.127,0,0,1-.187-.75A37.61,37.61,0,0,0,50,3.75H20V0H50A41.172,41.172,0,0,1,91.25,40.875l11.063,24a1.127,1.127,0,0,1,.188.75v3.75a1.771,1.771,0,0,1-1.875,1.875H91.25v15A13.044,13.044,0,0,1,78.125,99.375H68.75Z",
    transform: "translate(-20)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiWhite);
export default __webpack_public_path__ + "static/media/aiWhite.2f05b6bc6ddbc1d0125146474b7a5af7.svg";
export { ForwardRef as ReactComponent };